// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentProviderModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentProviderModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentProviderModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentProviderModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentProviderModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "officeContact",
        "baseName": "officeContact",
        "type": "string"
    },
    {
        "name": "officeContactFax",
        "baseName": "officeContactFax",
        "type": "string"
    },
    {
        "name": "officeContactPhone",
        "baseName": "officeContactPhone",
        "type": "string"
    },
    {
        "name": "officeContactTimePreferences",
        "baseName": "officeContactTimePreferences",
        "type": ""
    },
    {
        "name": "officeFax",
        "baseName": "officeFax",
        "type": "string"
    },
    {
        "name": "officePhone",
        "baseName": "officePhone",
        "type": "string"
    },
    {
        "name": "primaryAddress",
        "baseName": "primaryAddress",
        "type": "CoverMyMedsInboundEnrollmentAddressModel"
    },
    {
        "name": "siteInstitutionName",
        "baseName": "siteInstitutionName",
        "type": "string"
    },
    {
        "name": "stateLicenseNumber",
        "baseName": "stateLicenseNumber",
        "type": "string"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentProviderModel.js.map